import { useLocation } from 'js/lib/useRouter';

import { isInPasswordlessSignupVariant } from 'bundles/authentication/utils/experimentUtils';
import { ENROLL } from 'bundles/enroll/utils/enrollActionParams';

declare const COURSERA_APP_NAME: string;

const useIsInPasswordlessSignupFlow = () => {
  const appName = COURSERA_APP_NAME;

  const { action } = useLocation().query;
  return isInPasswordlessSignupVariant() && action === ENROLL && appName === 'consumer-description-page';
};

export default useIsInPasswordlessSignupFlow;
